// extracted by mini-css-extract-plugin
export default {"card":"card-y7OHw","disabled":"disabled-W40SV","content":"content-EdGUO"};